import { createAction, props } from '@ngrx/store';

export const showToasterMessage = createAction(
    '[TOASTER DISPLAY] Display toaster message',
    props<{ message: string; duration?: number }>()
);
